export default function render(el: HTMLElement) {
  const html = `<iframe src="https://sync.serverbid.com/syncs/audio.html" style="width:0px;height:0px;border-width:0px;"></iframe>`;
  el.insertAdjacentHTML('beforebegin', html);
};

